/* eslint-disable camelcase */
export interface IUpdateProductDTO {
  name?: string;
  description?: string;
  state?: string;
  start_date?: string;
  end_date?: string;
}

export default class UpdateProductDTO {
  public name?: string;

  public state?: string;

  public description?: string;

  public start_date?: string;

  public end_date?: string;

  constructor(data: IUpdateProductDTO) {
    this.name = data.name;
    this.state = data.state;
    this.description = data.description;
    this.start_date = data.start_date;
    this.end_date = data.end_date;
  }
}
